<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal" :title="`New ${reference.ref_type} Reference`" size="lg" :ok-title="`Save ${reference.ref_type} Reference`" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="subReferenceModal" :no-close-on-backdrop="true" :ok-disabled="saving" :cancel-disabled="saving" scrollable>

            <div v-if="loading" class="text-center">
                <i class="fa fa-circle-o-notch fa-spin"></i> Loading
            </div>
            <template v-else>
               <!--  <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.ref_type }">
                        Type: <i class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-7">

                        <b-form-select v-model="reference.ref_type" :options="refTypes" :class="{'is-invalid': errors.ref_type}"/>

                        <span v-if="errors.ref_type" class="text-danger">
                            <span v-for="error in errors.ref_type">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <hr /> -->

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.company_name }">
                        Company Name: <i v-if="!reference.company_name" class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="reference.company_name" :class="{'is-invalid': errors.company_name}" placeholder="Enter Company Name" />

                        <span v-if="errors.company_name" class="text-danger">
                            <span v-for="error in errors.company_name">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.contact_name }">
                        Contact Name: <i v-if="!reference.contact_name" class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="reference.contact_name" :class="{'is-invalid': errors.contact_name}" placeholder="Enter Contact Name" />

                        <span v-if="errors.contact_name" class="text-danger">
                            <span v-for="error in errors.contact_name">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row" v-if="reference.ref_type == 'Project'">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.project_name }">
                        Project Name: <i v-if="!reference.project_name" class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="reference.project_name" :class="{'is-invalid': errors.project_name}" placeholder="Enter Project Name" />

                        <span v-if="errors.project_name" class="text-danger">
                            <span v-for="error in errors.project_name">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row" v-if="reference.ref_type == 'Project'">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.total_amount }">
                        $ Amount of Work: <i v-if="!reference.total_amount" class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-7">

                        <b-input-group>
                            <template #prepend>
                                <b-input-group-text>$</b-input-group-text>
                            </template>
                            <b-form-input type="text" v-model="reference.total_amount" :class="{'is-invalid': errors.total_amount}" placeholder="Enter Total $ Amount of Work" />
                        </b-input-group>

                        <span v-if="errors.total_amount" class="text-danger">
                            <span v-for="error in errors.total_amount">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row" v-if="reference.ref_type == 'Project'">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.type_of_work_performed }">
                        Type of Work Performed: <i v-if="!reference.type_of_work_performed" class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="reference.type_of_work_performed" :class="{'is-invalid': errors.type_of_work_performed}" placeholder="Enter Type of Work Performed" />

                        <span v-if="errors.type_of_work_performed" class="text-danger">
                            <span v-for="error in errors.type_of_work_performed">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row" v-if="reference.ref_type == 'Project'">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.project_year_complete }">
                        Year Completed: <i v-if="!reference.project_year_complete" class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="reference.project_year_complete" :class="{'is-invalid': errors.project_year_complete}" placeholder="Enter the Year the Project was Completed" style="max-width: 100px;" />

                        <span v-if="errors.project_year_complete" class="text-danger">
                            <span v-for="error in errors.project_year_complete">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <hr/>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.phone }">
                        Phone: <i v-if="!reference.phone" class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="reference.phone" :class="{'is-invalid': errors.phone}" placeholder="Enter Contact Phone #" />

                        <span v-if="errors.phone" class="text-danger">
                            <span v-for="error in errors.phone">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.email }">
                        Email: <i v-if="!reference.email" class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-7">

                        <b-form-input type="text" v-model="reference.email" :class="{'is-invalid': errors.email}" placeholder="Enter Contact Email" />

                        <span v-if="errors.email" class="text-danger">
                            <span v-for="error in errors.email">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.address }">
                        Address: <i v-if="!reference.address" class="fa fa-asterisk text-danger small"></i>
                    </label>
                    <div class="col-md-7">

                        <b-form-textarea v-model="reference.address" :class="{'is-invalid': errors.address}" placeholder="Enter Address, City, State, Zip" rows="4"></b-form-textarea>

                        <span v-if="errors.address" class="text-danger">
                            <span v-for="error in errors.address">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <hr>

                <template v-if="reference.ref_type == 'Project'">
                    <div class="form-group row">
                        <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.letter_file }">
                            Project Reference Letter: <i v-if="!project_file && !reference.letter_file_id && reference.no_letter !== 1" class="fa fa-asterisk text-danger small" ></i>
                        </label>
                        <div class="col-md-7">

                            <b-form-file plain v-model="project_file" :class="{'is-invalid': errors.letter_file}"/>

                            <span v-if="errors.letter_file" class="text-danger">
                                <span v-for="error in errors.letter_file">{{ error }}</span>
                            </span>

                            <template v-if="reference.letter_file">
                                <hr/>
                                <div class="mb-2">
                                    <div>{{ reference.letter.file_name }}</div>
                                    <span v-if="!reference.letter.download_only">
                                        <a :href="`/files/view/${reference.letter.file_id}`" target="_blank">View</a>&nbsp;|&nbsp;
                                    </span>
                                    <a :href="`/files/download/${reference.letter.file_id}`" target="_blank">Download</a>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label :class="{ 'col-md-6 col-form-label text-sm-right': true, 'text-danger': errors.no_letter }">
                            No Reference Letter. Please contact this reference
                        </label>
                        <div class="col-md-5">
                            <b-form-checkbox v-model="reference.no_letter" :value="1" :unchecked-value="0" plain></b-form-checkbox>

                            <span v-if="errors.no_letter" class="text-danger">
                                <span v-for="error in errors.no_letter">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                </template>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            subcontractorId: {
                type: Number,
                default: null,
            },
        },

        data: function() {
            return {
                openModal: false,
                loading: false,
                saving: false,
                errors: {},
                reference: {},

                project_file: null,

                //Form Resources
                refTypes: {
                    'Project': 'Project',
                    'Trade/Credit': 'Trade/Credit',
                }
            }
        },

        methods: {

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Reset the values
                this.reference = {};
                this.errors = {};
                this.project_file = null;
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveForm();
            },

            showModal(){
                //Show ti
                this.openModal = true;
            },

            setModel(reference){
                this.reference = JSON.parse(JSON.stringify(reference));
            },

            saveForm(){
                //Reset errors
                this.errors = {};

                //Loading
                this.saving = true;

                //Send it
                this.$http
                .postWithSingleFile('subcontractors/reference/' + this.subcontractorId, this.reference, this.project_file, 'letter_file')
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Reference Saved');

                    //Emit
                    this.$store.commit('updateReferences', response.data);

                    //Close the modal
                    this.$refs.subReferenceModal.hide();

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //SEt the height
            //this.$refs.subReferenceModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
        }
    }
</script>